import React, { useEffect } from "react";
import { Grid, Typography, numeral, makeStyles, setLocale } from "../../../..";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import _ from "lodash";
var useStyles = makeStyles(function (theme) {
  return {
    positive: {
      color: theme.palette.primary.main
    },
    negative: {
      color: theme.palette.error.main
    },
    variationContainer: {
      display: "flex",
      alignItems: "flex-end",
      "flex-direction": "column",
      "padding-right": "20px"
    },
    icon: {
      width: "60px",
      height: "auto"
    },
    percentage: {
      display: "flex",
      alignItems: "center"
    },
    charts: {
      display: "flex",
      "justify-content": "space-between",
      padding: "25px"
    },
    fcolumn: {
      "flex-direction": "column",
      "min-width": "20%"
    },
    card: {
      minHeight: "200px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    content: {
      width: "80%",
      "text-align": "center",
      margin: "20px"
    },
    cardText: {
      background: "#b7b6b682",
      width: "100%",
      minHeight: "200px",
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
      borderRadius: "0 4px 4px 0",
      "flex-direction": "column",
      padding: "15px",
      "text-align": "center"
    },
    box: {
      display: "flex",
      "align-items": "center",
      "border-radius": "4px",
      border: "1px solid #7d7d7d"
    }
  };
});

var OfficeData = function OfficeData(_ref) {
  var dashboard = _ref.dashboard,
      country = _ref.country;
  var classes = useStyles();
  useEffect(function () {
    setLocale();
  }, []);
  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12,
    className: classes.charts
  }, dashboard && dashboard[country] && /*#__PURE__*/React.createElement("div", {
    className: [classes.charts, classes.fcolumn].join(" ")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      padding: "10px"
    }
  }, "Total"), /*#__PURE__*/React.createElement("div", {
    className: classes.box
  }, dashboard && dashboard[country] && [/*#__PURE__*/React.createElement(Typography, {
    className: classes.content,
    variant: "h5"
  }, dashboard && dashboard[country].total)])), dashboard && dashboard[country] && /*#__PURE__*/React.createElement("div", {
    className: [classes.charts, classes.fcolumn].join(" ")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      padding: "10px"
    }
  }, "Office 365"), /*#__PURE__*/React.createElement("div", {
    className: classes.box
  }, dashboard && dashboard[country] && [/*#__PURE__*/React.createElement(Typography, {
    className: classes.content,
    variant: "h5"
  }, dashboard && dashboard[country].office365)])), dashboard && dashboard[country] && /*#__PURE__*/React.createElement("div", {
    className: [classes.charts, classes.fcolumn].join(" ")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      padding: "10px"
    }
  }, "Mailbox"), /*#__PURE__*/React.createElement("div", {
    className: classes.box
  }, dashboard && dashboard[country] && [/*#__PURE__*/React.createElement(Typography, {
    className: classes.content,
    variant: "h5"
  }, dashboard && dashboard[country].mailbox)])));
};

export { OfficeData };